import { useSEO } from "../components/SEO";
import { ArrowLink } from "../components/CTA";
import { BookCallButton } from "../components/CTA";

export default function NotFound() {
  useSEO(
    "Page Not Found | Nexus Catalyst Agency",
    "The page you are looking for does not exist. Explore Nexus Catalyst's Hajj and Umrah marketing services for Indian travel agencies.",
    { noindex: true }
  );

  return (
    <main
      className="bg-cream min-h-screen flex items-center relative overflow-hidden"
      data-testid="not-found-page"
    >
      <div className="absolute inset-0 geo-pattern opacity-[0.05]" />
      <div className="relative max-w-7xl mx-auto px-6 py-40">
        <div className="text-7xl md:text-9xl font-bold tracking-tighter text-outline select-none">
          404
        </div>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold tracking-tight text-charcoal">
          {"This page has moved or never existed."}
        </h1>
        <p className="mt-4 text-base text-charcoal/60 max-w-lg leading-relaxed">
          {"The link may be outdated. Head back to the homepage or explore our Hajj and Umrah marketing services for Indian travel agencies."}
        </p>
        <div className="mt-8 flex flex-wrap gap-6 items-center">
          <ArrowLink to="/" testid="not-found-home-link">
            {"Back to Homepage"}
          </ArrowLink>
          <ArrowLink to="/services" testid="not-found-services-link">
            {"Explore Services"}
          </ArrowLink>
          <BookCallButton testid="not-found-contact-link" />
        </div>
      </div>
    </main>
  );
}
